import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import { makeSelectQueryStringNumberValue } from 'workspaces/react-router-selectors';

import { selectSpraySubmission } from 'services/spraySubmission/selectors';
import { SpraySubmissionProductId } from 'services/spraySubmission/types';

const selectSpraySubmissionPayload = createDeepEqualSelector(
    [
        selectSpraySubmission,
        makeSelectQueryStringNumberValue('spraySubmissionId')
    ],
    (spraySubmissions, spraySubmissionId: SpraySubmissionProductId) =>
        spraySubmissions && spraySubmissions[spraySubmissionId]?.payload
);

const makeSelectSpraySubmissionPayload =
    (): typeof selectSpraySubmissionPayload => selectSpraySubmissionPayload;

export { makeSelectSpraySubmissionPayload };
